import { combineReducers } from "redux";
import CartReducer from "slice/CartSlice";

const rootReducer = combineReducers({
  cart: CartReducer,
});

export default rootReducer;
